import React from 'react'
import PropTypes from 'prop-types'

const Placeholder = ({ width, height }) => (
  <div
    className={`episode-info-placeholder`}
    style={{
      width,
      height,
      backgroundColor: '#212121',
      borderRadius: '4px',
      // animation: 'pulse 1.5s ease-in-out infinite',
      display: 'inline-block',
    }}
  />
)

Placeholder.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

Placeholder.defaultProps = {
  width: '100%',
  height: '1rem',
}

export default Placeholder
